/**
 * API base URL.
 *
 * The API serves this build, so the default is the empty string, i.e. requests
 * go to the same origin the site is loaded from. That means the domain can
 * change without rebuilding the frontend.
 *
 * Set REACT_APP_API_BASE_URL at build time to point at a different host, e.g.
 * during local development when the API runs on another port.
 */

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

export const apiUrl = (path = '') =>
  `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

export default API_BASE_URL;
